app.service('productsInComparisonChecker', function(productsInComparison) {

	function group(groupId) {
		var list = productsInComparison.getByGroupId(groupId+"");
		var $buttons = $('.js-compare-add[data-product-group='+groupId+']');
		remove($buttons);
		list.forEach((item, i) => {
			add($buttons.filter('[data-product-id='+item.productId+']'))
		});
	}
	function add($element){
		$element.addClass('is-active').text('W porównaniu');
	}
	function remove($element){
		$element.removeClass('is-active').text('Porównaj');
	}
	function product(productId){
		var $buttons = $('.js-compare-add[data-product-id='+productId+']');
		if(productsInComparison.has(""+productId)){
			add($buttons);
		}else{
			remove($buttons)
		}
	}

	return {
		group, product
	};
});
